import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  checkoutsController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'authService',
    'EQuickAccessItems',
    'EDocumentStatus',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      $filter,
      $state,
      $controller,
      authService,
      EQuickAccessItems,
      EDocumentStatus
    ) {
      'use strict';

      function itemsFilter(item) {
        return item.idStatus === EDocumentStatus.IN_CHECKOUT;
      }

      function goToPage(page) {
        $state.go('home.checkouts', { page: page });
      }

      function loadDocuments() {
        //$rootScope.idCurrentFolder = EQuickAccessItems.CHECKOUTS;

        if ($scope.currentPage < 1) {
          $scope.goToPage(1);
        } else {
          $rootScope.currentDocument = null;
          $scope.count = 0;

          $scope.description = 'LOADING DOCUMENTS';
          $scope.documents(null);

          $scope.loading = true;

          var folderColumn = $scope.columns.filter((c) => c.id === 'folder')[0];
          if (folderColumn !== undefined && folderColumn !== null)
            folderColumn.disabled = false;

          revisionService.cancelLoadRevisions();
          $rootScope.$broadcast('loadFolder', EQuickAccessItems.CHECKOUTS);

          revisionService
            .loadRevisionsCheckouts($scope.currentPage, $scope.pageSize)
            .then(
              function (data) {
                $scope.count = data.length;

                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

                $scope.loading = false;

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  authService.getUserAsync().then(user => {
                    user.userPreferences.IdLastFolder = EQuickAccessItems.CHECKOUTS;
                  });

                  $scope.documents(data);
                  // $scope.documents(data.result);

                  $scope.groups = [];

                  $scope.description = $scope.getDescription(
                    $scope.currentPage,
                    $scope.pageSize,
                    $scope.count
                  );

                  if (authService.authentication.email !== 'autologin') {
                    var date = $scope.columns.filter(function (c) {
                      return c.id === 'date';
                    })[0];
                    date.sorted = 'asc';
                    $scope.sortColumn(date);
                  } else {
                    var title = $scope.columns.filter(function (c) {
                      return c.id === 'title';
                    })[0];
                    title.sorted = '';
                    $scope.sortColumn(title);
                  }
                }
              },
              function (data) {
                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers

                if (
                  data.status_code === 500 &&
                  $scope.selectedTreeItem.Name === 'CHECKOUTS'
                ) {
                  $scope.documents([]);
                  return;
                }
                swal.fire(data.error, data.error_description);
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers
              }
            );
        }
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('CHECKOUTS');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO CHECKOUTS');
          $scope.noDocumentsMessage = $filter('translate')('NO CHECKOUTS MSG');

          if (!$state.params.page) {
            $state.transitionTo('home.checkouts', { page: 1 });
          }

          $scope.currentPage = $state.params.page
            ? parseInt($state.params.page)
            : 1;

          $scope.pageSize = 100;
          $scope.pageCount = 1;
          $scope.groups = null;
          $scope.currentGroup = null;
          $scope.columns = [];
          $scope.canView = false;
          $scope.loading = true;
          $scope.count = 0;

          $scope.itemsFilter = logWrapper(
            itemsFilter,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadDocuments = logWrapper(
            loadDocuments,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.configColumns();
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
